import React from 'react';
import Logo from '../Img/logo.png';
import Axios from 'axios'
import Cleave from "cleave.js/react"
import "cleave.js/dist/addons/cleave-phone.br"
import { Link } from 'react-router-dom';

export class PerfilCliente extends React.Component {
  constructor(props) {
    window.localStorage.setItem("rotaAtual", window.location.href.split('/')[3]);
super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem('user')),
      ...JSON.parse(localStorage.getItem('user'))
      ,
      nome : '', 
      email: '', 
      telefone: '', 
      cpf: '',
      endereco: '',
      bairro: '',
      cidade: '',
      estado: '',
      senha: '',
      confirmarSenha: '',
      status: true
    };
    this.getUsuario();
  }

  logout(){
    window.localStorage.setItem("rotaAtual", "");
    this.props.history.push('/')
}

  initAlizer(){
    var user = JSON.parse(localStorage.getItem("user"));
    
    if(user.telefone == undefined) user = {...user, telefone: ''}
    if(user.cpf == undefined || user.cpf == null) user = {...user, cpf: ''}
    if(user.endereco == undefined) user = {...user, endereco: ''}
    if(user.bairro == undefined) user = {...user, bairro: ''}
    if(user.cidade == undefined) user = {...user, cidade: ''}
    if(user.estado == undefined) user = {...user, estado: ''}

    this.setState({
      nome : user.nome, 
      email: user.email, 
      telefone: user.telefone, 
      cpf: user.cpf,
      endereco: user.endereco,
      bairro: user.bairro,
      cidade: user.cidade,
      estado: user.estado,
      status: true
    })
  }

  async getUsuario () {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.post("usuarios/get-usuario", {
        id: this.state.user._id
      });
      window.localStorage.setItem('user', JSON.stringify(response.data));
      this.setState({ user: response.data});
      this.initAlizer()
    } catch (err) {
      console.log(err);
    }
  };

  handlerChange(e){
    const {name, value} = e.target;
    this.setState({...this.state, [name] : value})
    console.log(this.state)
  }


  async atualizarCliente(e){
    if(this.state.telefone != undefined && this.state.endereco != undefined && this.state.bairro != undefined && this.state.cidade != undefined && this.state.estado != undefined){
        if(this.state.telefone.length < 10)
        {
          alert("Preencha seu telefone corretamento!")
        return ;
      }
        if(this.state.endereco.length < 5)
        {
        alert("Preencha seu endereço corretamento!")
        return ;}
        if(this.state.bairro.length < 5)
        {
        alert("Preencha seu bairro corretamento!")
        return;}
        if(this.state.cidade.length < 5)
        {
        alert("Preencha sua cidade corretamento!")
        return;
        }
        if(this.state.estado.length == 0)
        {
          alert("Preencha seu estado corretamento!")
          return;
        }
        if(this.state.senha != "" && this.state.confirmarSenha != this.state.senha){
          alert("Confirme a senha, os campos não conferem!")
          return;
        }
        if(this.state.senha.length > 1 && this.state.senha.length < 6 ){
          alert("Preencha sua senha corretamento!")
          return;
        }
        else if(this.state.senha.length > 5){

          try {
            var axiosInstance = new Axios.create({
              baseURL: window.localStorage.getItem("apiUrl")
            });
            const response = await axiosInstance.post("usuarios/atualizar-cliente-com-senha", 
            {
              id: this.state.user._id,
              nome: this.state.nome,
              email: this.state.email,
              endereco: this.state.endereco,
              bairro: this.state.bairro,
              cidade: this.state.cidade,
              estado: this.state.estado,
              telefone: this.state.telefone,
              cpf: this.state.cpf,
              senha: this.state.senha,
              status: true
            });

            alert("Atualizado com sucesso! nova senha!")
            console.log(response.data)
            if(response.data){
              // window.location.reload()
            }

          } catch (err) {
            console.log(err);
          }

        }
        else if(this.state.senha == ""){

          try {
            var axiosInstance = new Axios.create({
              baseURL: window.localStorage.getItem("apiUrl")
            });
            const response = await axiosInstance.post("usuarios/atualizar-usuario-manter-senha", 
            {
              usuarioId: this.state.user._id,
              nome: this.state.nome,
              email: this.state.email,
              endereco: this.state.endereco,
              cpf: this.state.cpf,
              bairro: this.state.bairro,
              cidade: this.state.cidade,
              estado: this.state.estado,
              telefone: this.state.telefone,
              status: true
            });

            alert("Atualizado com sucesso! ")
            console.log(response.data)
            if(response.data){}
              // window.location.reload()

          } catch (err) {
            console.log(err);
          }

        }
    }
    else{
      alert("Preencha os campos vazios!")
      this.initAlizer()
    }
  }

  async  reload(){
    await window.location.reload()
  }
  
  render() {
  
    const logout = () => {
      window.localStorage.removeItem('user')
      window.localStorage.removeItem("rotaAtual");
      window.location.href = '/'
  }
  
       const removeToggled = (e) => {
           window.localStorage.setItem("rotaAtual", e.target.name);
           setTimeout(this.reload, 100)
       }
    return (
      <div>
        <div class="wrapper">
          <div class="sidebar" data-image="/assets/img/sidebar-5.jpg">
            <div class="sidebar-wrapper">
              <div class="logo">
                <img src={Logo} style={{ width: '10em', height: '4em' }} />
              </div>

              <ul class="nav">
              <li class="nav-item">
                <Link onClick={logout} className="nav-link" >
                    <i class="fas fa-sign-out-alt"></i>
                            <span>SAIR</span>
                  </Link>
                </li>
                <li class="nav-item">
                  <Link class="nav-link" to="minhas-cartelas" name="minhas-cartelas" onClick={removeToggled.bind(this)}>
                    <i class="nc-icon nc-layers-3" />
                    <p>Minhas cartelas</p>
                  </Link>
                </li>
                <li>
                  <Link class="nav-link" to="loja-cliente" name="loja-cliente" onClick={removeToggled.bind(this)}>
                    <i class="nc-icon nc-istanbul" />
                    <p>Loja</p>
                  </Link>
                </li>
                <li class="nav-item">
                  <Link class="nav-link" to="ganhadores" name="ganhadores" onClick={removeToggled.bind(this)}>
                    <i class="nc-icon nc-satisfied" />
                    <p>ult. ganhadores</p>
                  </Link>
                </li>
                <li class="nav-item active">
                  <Link class="nav-link" to="perfil-cliente" name="perfil-cliente" onClick={removeToggled.bind(this)}>
                    <i class="nc-icon nc-circle-09" />
                    <p>Perfil</p>
                  </Link>
                </li>
                <li style={{padding: '8px'}}>
                  <Link style={{border: '3px solid white', borderRadius: '6px'}} class="nav-link"  name="aplicativo" onClick={() => {window.location.href = "https://www.sorteflash.com/download/sorteflash-app.apk"}}>
                    <i class="fa fa-android"></i> 
                    <p>Novo aplicativo</p>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div class="main-panel">
            <nav class="navbar navbar-expand-lg " color-on-scroll="500">
              <div class="container-fluid">
                <Link class="navbar-brand" to="#">
                  {" "}
                  Perfil{" "}
                </Link>
                <button
                  to=""
                  class="navbar-toggler navbar-toggler-right"
                  type="button"
                  data-toggle="collapse"
                  aria-controls="navigation-index"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span class="navbar-toggler-bar burger-lines" />
                  <span class="navbar-toggler-bar burger-lines" />
                  <span class="navbar-toggler-bar burger-lines" />
                </button>
                <div
                  class="collapse navbar-collapse justify-content-end"
                  id="navigation"
                >
                  <ul class="navbar-nav ml-auto">
                  {/* <li class="nav-item">
                      <Link class="nav-link" onClick={this.logout}>
                        <span class="no-icon">Sair</span>
                      </Link>
                    </li> */}
                  </ul>
                </div>
              </div>
            </nav>
            <div class="content">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-md-8">
                    <div class="card">
                      <div class="card-header">
                        <h4 class="card-title">Perfil</h4>
                      </div>
                      <div class="card-body">
                          <div class="row">
                            <div class="col-md-5 pr-1">
                              <div class="form-group">
                                <label>Perfil</label>
                                <input
                                  type="text"
                                  disabled
                                  class="form-control"
                                  placeholder="Perfil"
                                  value={this.state.perfil}
                                />
                              </div>
                            </div>
                            <div class="col-md-3 px-1">
                              <div class="form-group">
                                <label>Nome</label>
                                <input
                                disabled
                                  type="text"
                                  name="nome"
                                  value={this.state.nome}
                                  class="form-control"
                                  placeholder="Nome"
                                  onChange={this.handlerChange.bind(this)}
                                />
                              </div>
                            </div>
                            <div class="col-md-4 pl-1">
                              <div class="form-group">
                                <label for="exampleInputEmail1">Email</label>
                                <input
                                disabled
                                  type="email"
                                  name="email"
                                  class="form-control"
                                  placeholder="Email"
                                  value={this.state.email}
                                  onChange={this.handlerChange.bind(this)}
                                />
                              </div>
                            </div>
                          </div>

        <div className="row m-1">
        <div class="form-group">
                                <label>CPF</label>
        <Cleave placeholder="999.999.999-99"
                            value={this.state.cpf}
                            name="cpf" 
                            data-length="11"
                            className={`form-control `}
                            options={{
                                numericOnly: true,
                                delimiters: ['.', '.', '-'],
                                blocks: [3, 3, 3, 2]
                            }}
                            onChange={this.handlerChange.bind(this)}
                    />
                    </div>
          <div class="ml-2 form-group">
                                <label>Telefone</label>
        <Cleave name="telefone"
                            placeholder="99 99999 9999"
                            data-length="10"
                            value={this.state.telefone}
                            className="form-control"
                            options={{
                                phone: true,
                                phoneRegionCode: 'BR'
                            }}
                            onChange={this.handlerChange.bind(this)}
                    />
                          </div>
        </div>
                          <div class="row">
                            <div class="col-md-12">
                              <div class="form-group">
                                <label>Endereço</label>
                                <input
                                  name="endereco"
                                  type="text"
                                  class="form-control"
                                  placeholder="Endereço"
                                  value={this.state.endereco}
                                  onChange={this.handlerChange.bind(this)}
                                />
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-4 pr-1">
                              <div class="form-group">
                                <label>Cidade</label>
                                <input
                                  type="text"
                                  name="cidade"
                                  class="form-control"
                                  placeholder="City"
                                  value={this.state.cidade}
                                  onChange={this.handlerChange.bind(this)}
                                />
                              </div>
                            </div>
                            <div class="col-md-4 px-1">
                              <div class="form-group">
                                <label>Bairro</label>
                                <input
                                  type="text"
                                  name="bairro"
                                  class="form-control"
                                  placeholder="Bairro"
                                  value={this.state.bairro}
                                  onChange={this.handlerChange.bind(this)}
                                />
                              </div>
                            </div>
                            <div class="col-md-4 px-1">
                              <div class="form-group">
                                <label>Estado</label>
                                <input
                                  type="text"
                                  name="estado"
                                  class="form-control"
                                  placeholder="UF"
                                  value={this.state.estado}
                                  onChange={this.handlerChange.bind(this)}
                                />
                              </div>
                            </div>
                            <div class="col-md-4 pl-1">
                            </div>
                          </div>
                          <div className="row">
                          <div className="row m-1 mt-3">
                          <input className="form-control" name="senha"  placeholder="NOVA SENHA"  onChange={this.handlerChange.bind(this)} ></input>
                            </div>
                            <div className="row m-1 mt-3">
                                <input className="form-control" name="confirmarSenha" value={this.state.confirmarSenha} placeholder="CONFIRMAR SENHA"  onChange={this.handlerChange.bind(this)} ></input>
                            </div>
                            <div className="row m-1 mt-3">
                                <button className="btn-fill btn btn-success" onClick={this.atualizarCliente.bind(this)}>SALVAR ALTERAÇÕES</button>
                            </div>
                          </div>
                          <div class="clearfix" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <footer class="footer">
              <div class="container-fluid">
                <nav>
                  <ul class="footer-menu">
                    <li>
                      <Link to="#">Empresa</Link>
                    </li>
                    <li>
                      <Link to="#">Regulamento</Link>
                    </li>
                    <li>
                      <Link to="#">Outros projetos</Link>
                    </li>
                  </ul>
                  <p class="copyright text-center">
                    Proprietário ©
                    <Link to="https://www.instagram.com/sorteflash/">SorteFlash</Link>
                  </p>
                </nav>
              </div>
            </footer>
          </div>
        </div>
      </div>
    );
  }
}

export default PerfilCliente;
